import { gql } from "@apollo/client";

export const DashboardPeopleTableUserMeetingFragment = gql`
  fragment DashboardPeopleTableUserMeetingFragment on MeetingNode {
    id
    meetingGroupId
    startDatetime
  }
`;

export const DashboardPeopleTableUserArtifactsFragment = gql`
  fragment DashboardPeopleTableUserArtifactsFragment on UserNode {
    id
    primaryManager {
      id
    }
    goals: ownedGoals(goalState: open, first: $peopleTableGoalMax) {
      totalCount
      edges {
        node {
          id
          ... on GoalArtifactNode {
            title
            artifactType
            state
            isStale
            status
            canUpdate {
              permission
            }
            progress
            startValue
            currentValue
            targetValue
            progressType
          }
        }
      }
    }
    mostRecentlyReceivedRecognition {
      id
      artifactType
      created
    }
  }
`;

export default gql`
  ${DashboardPeopleTableUserArtifactsFragment}
  ${DashboardPeopleTableUserMeetingFragment}
  query getPeopleTableMetadataQuery(
    $oneononeUserIds: [Int]!
    $hasOneononeUserIds: Boolean!
    $meetingUserIds: [Int]!
    $hasMeetingUserIds: Boolean!
    $peopleTableGoalMax: Int!
    $now: DateTime!
    $currentUserId: Int!
  ) {
    oneononeUsers: users(ids: $oneononeUserIds)
      @include(if: $hasOneononeUserIds) {
      edges {
        node {
          id
          ...DashboardPeopleTableUserArtifactsFragment
          meetings(
            isFormalOneonone: true
            participants: [$currentUserId]
            startDatetime_Gte: $now
            first: 1
            orderBy: "startDatetime"
          ) {
            edges {
              node {
                ...DashboardPeopleTableUserMeetingFragment
              }
            }
          }
        }
      }
    }
    meetingUsers: users(ids: $meetingUserIds) @include(if: $hasMeetingUserIds) {
      edges {
        node {
          id
          ...DashboardPeopleTableUserArtifactsFragment
          meetings(
            isFormalOneonone: false
            participants: [$currentUserId]
            startDatetime_Gte: $now
            first: 1
            orderBy: "startDatetime"
          ) {
            edges {
              node {
                ...DashboardPeopleTableUserMeetingFragment
              }
            }
          }
        }
      }
    }
  }
`;
